export default __webpack_public_path__ + "static/media/gal05.12f8ca42.svg";